// import { reduxForm, Field } from 'redux-form';
import { modalsHide, updateVehicle } from 'actions';
import { normalizeFormattedField } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { salesAdapter, salesApiSlice as api } from 'services/api/sales';
import { useEffect, useState } from 'react';
// @ts-ignore
import setFieldData from 'final-form-set-field-data';
import { useIsAlternativeAuction } from 'hooks';
import { EditVehicleBidForm } from './EditVehicleBidForm';

const EditVehicleBidModal = ({ form: modalName, initialValues }: any) => {
  const isAlternativeAuction = useIsAlternativeAuction(initialValues);

  // const [updateVehicle] = useSalesVehicleUpdateMutation();

  const dispatch = useDispatch();

  const { page, perPage, filters } = useSelector((state: any) => state.mySales);

  const [dropReserveModalOpen, setDropReserveModalOpen] = useState(false);

  const submitForm = (values: any) => {
    const {
      bids,
      highestBid,
      active_alternative_offer,
      top_alternative_bid_offer,
      alternative_offers,
      alternative_bid_offers,
      highest_bid,
      awarded_user,
      current_bid,
      auction,
      ...vehicle
    } = values;

    dispatch(
      updateVehicle({
        ...vehicle,
        auction_type: auction?.type,
        alternative_offer: normalizeFormattedField(values.alternative_offer ?? ''),
        cost: normalizeFormattedField(values.cost ?? ''),
        stock: values.stock ?? '',
        notes: values.notes ?? '',
        updateOptions: false,
        reserve_price: normalizeFormattedField(values.reserve_price ?? ''),
        starting_bid: normalizeFormattedField(values.starting_bid ?? ''),
        updateText: 'Vehicle updated',
        refetchMySales: true,
        redirect: false
      }).request
    );

    const newReserve = (() => {
      const normalized = values.reserve_price ? normalizeFormattedField(values.reserve_price ?? '') : null;
      if (!isAlternativeAuction) {
        return normalized;
      }

      const alternative_offer = vehicle.alternative_offer;
      if (!alternative_offer) return normalized;
      return Math.min(alternative_offer, normalized);
    })();

    dispatch(
      // @ts-ignore
      api.util.updateQueryData(
        'getMySales',
        {
          limit: perPage,
          offset: page,
          ...filters
        },
        draft => {
          salesAdapter.updateOne(draft.rows, {
            id: vehicle.id,
            changes: {
              reserve_price: newReserve
            }
          });
        }
      )
    );

    setDropReserveModalOpen(false);
    dispatch(modalsHide(`confirm-update-${vehicle.id}`));
  };

  return (
    <Form
      mutators={{ setFieldData }}
      name={modalName}
      onSubmit={submitForm}
      style={{ maxWidth: '367px' }}
      initialValues={initialValues}
      keepDirtyOnReinitialize
    >
      {({ handleSubmit }) => {
        return (
          <EditVehicleBidForm
            dropReserveModalOpen={dropReserveModalOpen}
            setDropReserveModalOpen={setDropReserveModalOpen}
            handleSubmit={handleSubmit}
            modalName={modalName}
          />
        );
      }}
    </Form>
  );
};

export default EditVehicleBidModal;
